export default __webpack_public_path__ + "a0376ffefda9a1a2d80eaecd0bb43fca.woff2";